export const BASE_API_URL =
  process.env.REACT_APP_APP_ENV === "prod" || process.env.REACT_APP_APP_ENV === "PROD"
    ? process.env.REACT_APP_BASE_API_URL_PROD
    : process.env.REACT_APP_BASE_API_URL_DEV;
